import { JSX } from "react";

import { BATCH_ROW_TEST_ID } from "../../utils/batch-row-test-ids";
import { BatchItem } from "../shared/batch-action-modal";
import { BatchRowHeader } from "./batch-row-header";

interface BatchSimpleRowProps {
  id: number;
  item: BatchItem;
}

export function BatchSimpleRow({ id, item }: BatchSimpleRowProps): JSX.Element {
  return (
    <div
      data-testid={BATCH_ROW_TEST_ID(id)}
      className="flex flex-col gap-2 rounded-lg border bg-gray-50 p-3"
    >
      <BatchRowHeader id={id} item={item} />
    </div>
  );
}
